import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircleFill, ArrowLeft } from 'react-bootstrap-icons';
import './EmployeeRegisterSuccess.css';

const EmployeeRegisterSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { name = '', photoUrl = '', updatedAt = '' } = location.state || {};
  const updatedAtText = updatedAt ? new Date(updatedAt).toLocaleString('en-GB') : '';
  const resolvedPhotoUrl = photoUrl
    ? (/([?&])v=/.test(photoUrl)
      ? photoUrl
      : `${photoUrl}${photoUrl.includes('?') ? '&' : '?'}v=${encodeURIComponent(updatedAt || Date.now())}`)
    : '';

  const handleRegisterAnother = () => {
    navigate('/employee/register', { replace: true });
  };

  return (
    <div className="employee-register-success-page">
      <div className="employee-register-success-card">
        <div className="employee-register-success-icon">
          <CheckCircleFill />
        </div>
        <h1>EMPLOYEE REGISTRATION SUBMITTED SUCCESSFULLY.</h1>
        <p className="employee-register-success-caption">
          OUR HR TEAM WILL REVIEW YOUR INFORMATION SHORTLY.
        </p>
        {resolvedPhotoUrl ? (
          <div className="employee-register-success-photo">
            <img src={resolvedPhotoUrl} alt={name ? `${name} PHOTO` : 'EMPLOYEE PHOTO'} />
          </div>
        ) : null}
        {name && <p className="employee-register-success-name">{name}</p>}
        {updatedAtText && (
          <p className="employee-register-success-caption">
            UPDATED AT: {updatedAtText}
          </p>
        )}
        <button type="button" className="employee-register-success-button" onClick={handleRegisterAnother}>
          <ArrowLeft /> BACK TO REGISTRATION FORM
        </button>
      </div>
    </div>
  );
};

export default EmployeeRegisterSuccess;
